import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class TwiggsMFTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const twiggsMF = isDefined(currentItem) && yAccessor(currentItem);
    const value = (twiggsMF && displayFormat(twiggsMF)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Hide tooltip if value is n/a
    if (shouldHideField(value)) {
      return null;
    }

    const period = options?.period || 21;
    const tooltipLabel = `TMF (${period}): `;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-twiggs-mf"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{value}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

TwiggsMFTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    period: PropTypes.number,
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

TwiggsMFTooltip.defaultProps = {
  displayFormat: (d) => formatNumber(d, 4),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default TwiggsMFTooltip;
